










































































































































































import Vue from "vue";
import { mapGetters } from "vuex";
import HasRole from "@/components/HasRole.vue";
import { ROLES } from "@/enums";
import GetterTypes from "@/store/GetterTypes";

interface State {
  ROLES: any;
  dialog: boolean;
  iCalType: any;
  iCalTypes: any;
  players: any;
}

export default Vue.extend({
  name: "iCalModal",
  components: { HasRole },
  data: (): State => {
    return {
      ROLES: ROLES,
      dialog: false,
      iCalType: null,
      iCalTypes: {
        apple: {
          prefix: "webcal://",
          name: "apple"
        },
        google: {
          prefix: "https://www.google.com/calendar/render?cid=webcal://",
          name: "google"
        },
        outlook: {
          prefix: "webcal://",
          name: "outlook"
        },
        microsoft: {
          prefix: "webcal://",
          name: "microsoft"
        }
      },
      players: null
    };
  },

  async mounted() {
    this.players = this.playersAndTeams.players;
  },

  methods: {
    getOrgUnitsConcat(orgUnits: any) {
      return orgUnits.map((ou: any) => ou.name).join(", ");
    },
    selectIcalPrefix(type: any) {
      this.iCalType = type;
    },
    getDefaultUrl() {
      return `${
        this.iCalType ? this.iCalType.prefix : this.iCalTypes.apple.prefix
      }${window.location.host}/user/ical/${this.user.icalToken}.ics`;
    },
    redirectTo(url: string) {
      window.open(url, "_blank");
    }
  },
  computed: {
    coachIcal(): string {
      return `${this.iCalType.prefix}${window.location.host}/user/icalCoach/${this.user.icalToken}.ics`;
    },
    userIcal(): string {
      return `${this.iCalType.prefix}${window.location.host}/user/ical/${this.user.icalToken}.ics`;
    },
    playerIcal(): (id: string) => string {
      return (id: string) =>
        `${this.iCalType.prefix}${window.location.host}/user/ical/${this.user.icalToken}.ics?pid=${id}`;
    },
    ...mapGetters({
      user: GetterTypes.GET_USER,
      playersAndTeams: GetterTypes.GET_PLAYERS_AND_TEAMS
    })
  }
});
